import React, { Component } from "react";
// import {MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem,  MDBNavbarToggler, MDBCollapse, MDBFormInline, MDBNavLink} from "mdbreact";
import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";
// import {Container} from 'semantic-ui-react'
import { withRouter } from 'react-router'
import Footer from "../../Footer";
import menus from "../Helpers/menus";
import NHP from "../../../images/NHPLogo.png";
import NRSC from "../../../images/ISRO_NRSC_Logo.png";
import { Grid, Header, Image } from "semantic-ui-react";
import bhuvan_logo from "../../../images/bhuvan_logo.png";
import bhuvan_logo_small from "../../../images/bhuvanLogo.png";
import info from '../../info.png'
import decode from "jwt-decode";
import colors from "../../colors"
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "mdbreact";
import { AuthConsumer } from "../../AuthContext";

import urls from '../../urls'
import HeaderCommon from "../../HeaderCommon";
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      atlas: false,
      active: props.match.url === '/webgis-glacials' ? 'GLOF Home' : props.match.url === '/webgis-glacials/map' ? 'GLOF Geoportal' : props.match.url === '/webgis-glacials/proj-obj' ? 'Objective' : null,
      isOpen: false,
      glmodal:true,
      isIndusOpen: false, // Navbar toggle state
      isGangaOpen: false, // Submenu toggle state
      isBramhaputraOpen: false, // Sub-submenu toggle state

    };

  }

  //this.toggleSuruSubMenu = this.toggleSuruSubMenu.bind(this);
  toggleIndus = () => {
    console.log("isIndusOpen, isGangaOpen, isBram")
    this.setState(prevState => ({
      isIndusOpen: !prevState.isIndusOpen, // toggle the state between true and false
      isGangaOpen: false, 
      isBramhaputraOpen: false 
    
    }));
  };

  toggleGanga = () => {
    this.setState({ 
      isGangaOpen: !this.state.isGangaOpen,
      isIndusOpen: false, 
      isBramhaputraOpen: false 
    });
  };
  
  toggleBramhaputra = () => {
    this.setState({ 
      isBramhaputraOpen: !this.state.isBramhaputraOpen,
      isIndusOpen: false, 
      isGangaOpen: false 
    });
  };
  toggle=()=>{
    this.setState({
      glmodal:!this.state.glmodal,
      isIndusOpen: false, // Navbar toggle state
      isGangaOpen: false, // Submenu toggle state
      isBramhaputraOpen: false, // Sub-submenu toggle state

    })
  }
  toggleAtlas = () => {
    this.setState({
      atlas: !this.state.atlas,
      isIndusOpen: false, // Navbar toggle state
      isGangaOpen: false, // Submenu toggle state
      isBramhaputraOpen: false, // Sub-submenu toggle state

    })
  }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
      isIndusOpen: false, // Navbar toggle state
      isGangaOpen: false, // Submenu toggle state
      isBramhaputraOpen: false, // Sub-submenu toggle state

    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
    this.onClick()
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.url !== prevProps.match.url) {
      this.setState({
        active: this.props.match.url === '/webgis-glacials' ? 'GLOF Home' : this.props.match.url === '/webgis-glacials/map' ? 'GLOF Geoportal' : this.props.match.url === '/webgis-glacials/proj-obj' ? 'Objective' : null,
      
      })
    }
  }
  render() {
    const activeStyle = { color: "#ff3333" };
    const { isIndusOpen, isGangaOpen, isBramhaputraOpen } = this.state;
    console.log("this.state.....",this.state.isBramhaputraOpen,this.state.isGangaOpen,this.state.isIndusOpen)

    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
    const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
        //this properties are available as a props in child components
         glmodal:this.state.glmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    // let crumbs= menus.breadCrumbs.map((menu, key)=>{
    //     if(key!==menus.breadCrumbs.length-1){
    //     return(

    //        <span style={{fontFamily:"Helvetica"}} key={key}>
    //            <Breadcrumb.Section link>{menu.name}</Breadcrumb.Section>
    //            <Breadcrumb.Divider icon='right chevron' />
    //        </span>

    //     )}else{
    //         return(

    //         <span style={{fontFamily:"Helvetica"}} key={key}>
    //             <Breadcrumb.Section link>{menu.name}</Breadcrumb.Section>

    //         </span>

    //      )}

    // })
    return (
      <div className="wrapper">
        <HeaderCommon
          title=" Himalayan Glacial Lakes Information System"
          screentitle="Glacial Lakes"
          bhuvanlink={true}
        />

        {/* <Grid
        columns="equal"
        divided
        style={{ marginLeft: "0rem", marginRight: "-2rem" }}
      >
        <Grid.Row style={{ paddingTop: "1em", paddingBottom: "0em" }} stretched>
          <Grid.Column>
            <Menu as={Header} attached style={{ backgroundColor: "#" }}>
              <Grid.Column floated="left">
                <Header as="h3">
                  <a
                    href="https://www.isro.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {" "}
                    <img src={NRSC} height="64px" className="image_resize" />
                  </a>
                  
                    <a
                      href="https://bhuvan-app1.nrsc.gov.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    > */}
        {/* <span className="full-text">
                        <img src={bhuvan_logo} height="64px" alt="bhuvan" />
                      </span>
                      <span className="short-text">
                        <img
                          src={bhuvan_logo_small}
                          height="64px"
                          alt="bhuvan"
                        />
                      </span>{" "} 
                    </a>
               
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header as="h2" textAlign="center">
                  <Header.Content className="middle">
                  Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial Lakes in the Himalayan Region of Indian River Basins
                  
                      {/* <Header.Subheader className="middle1">
                        National Remote Sensing Centre
                      </Header.Subheader> */}

        {/* </Header.Content> */}
        {/* </Header>
              </Grid.Column>
              <Grid.Column floated="right">
             
                <Header as="h3" textAlign="left">
                <span className="full-text"> Version 1.0</span>
                <span className="short-text">V 1.0</span>
                  <a
                    href="http://nhp.mowr.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {" "}
                    <img src={NHP} height="64px" />
                  </a>
                </Header>
              </Grid.Column>
            </Menu>
          </Grid.Column>
        </Grid.Row>
      </Grid> */}

<Navbar 
  dark 
  expand="md" 
  scrolling 
  style={{ 
    background: colors.final_footer, 
   // fontSize: "14px", 
   // fontWeight: "bold",
  }}
>
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left >{menuList}
            <NavItem>
              <Dropdown
                isopen={this.state.atlas}
                toggle={this.toggleAtlas}
              >
             
                  <DropdownToggle nav caret className="second-step">

                    Atlas
                  </DropdownToggle>
                  <DropdownMenu>


                    <DropdownItem>
                      <a href={urls.glofindusatlas_live} target="_blank" rel='noopener noreferrer'>Indus</a>
                    </DropdownItem>

                    <DropdownItem divider />
                    <DropdownItem>

                      <a href={urls.glofgangaatlas_live} target="_blank" rel='noopener noreferrer'>Ganga</a>
                    </DropdownItem>

                    <DropdownItem divider />
                    <DropdownItem>

                      <a href={urls.glofbrahmaputraatlas_live} target="_blank" rel='noopener noreferrer'>Brahmaputra</a>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>

                    <a href={urls.IHR_GlacialLake_Atlas} target="_blank" rel='noopener noreferrer'>Indian Himalayan River Basins</a>
                    </DropdownItem>
                  
                  </DropdownMenu>
              </Dropdown>

          </NavItem>

          <NavItem>
              <Dropdown
                isopen={this.state.atlas}
                toggle={this.toggleAtlas}
              >
             
                  <DropdownToggle nav caret className="second-step">

                    Reports
                  </DropdownToggle>
                 
                      <DropdownMenu>

                      <Dropdown isOpen={this.state.isIndusOpen} toggle={this.toggleIndus} direction="right" 
                      >
                      <DropdownToggle
                             className="custom-dropdown-toggle"
                             nav
                            caret



                            style={{ padding: "0.25rem 1.5rem", backgroundColor: "transparent", border: "none" }}
                            onClick={this.toggleIndus} // Directly pass the method without an arrow function
                          >  Indus
                    </DropdownToggle>
                    <DropdownItem divider />

                    
                    {this.state.isIndusOpen &&(
                       <DropdownMenu >
                        

                        {/* <DropdownItem
                                    onClick={() => {
                                      this.toggleIndus(); // Close the dropdown
                                      window.open(urls.GhepangGhat, "_blank", "noopener noreferrer");
                                    }}
                                  > */}
                        <DropdownItem>
                      <a href={urls.GhepangGhat}  onClick={() => {
                                      this.toggleIndus() }} target="_blank" rel='noopener noreferrer'>Ghepang Ghat GLOF Risk Assessment</a>
                      </DropdownItem>


                       <DropdownItem>
                         <a href={urls.Katkar}  onClick={() => {
                                      this.toggleIndus() }} target="_blank" rel='noopener noreferrer'>Katkar Lake GLOF Risk Assessment</a>
                           </DropdownItem>
                       <DropdownItem>
                         <a href={urls.Mundiksar}  onClick={() => {
                                      this.toggleIndus() }} target="_blank" rel='noopener noreferrer'>Mundiksar Lake GLOF Risk Assessment</a>
                           </DropdownItem>
                              
                       <DropdownItem>
                         <a href={urls.SamudraTapu}  onClick={() => {
                                      this.toggleIndus() }}target="_blank" rel='noopener noreferrer'>SamudraTapu Lake GLOF Risk Assessment</a>
                       </DropdownItem>
                       <DropdownItem>
                         <a href={urls.Suru}  onClick={() => {
                                      this.toggleIndus() }} target="_blank" rel='noopener noreferrer'>Suru Lake GLOF Risk Assessment</a>
                       </DropdownItem>
                       </DropdownMenu>
                      )}
                   
                  
                  </Dropdown>
                  <Dropdown isOpen={isGangaOpen} toggle={this.toggleGanga}>
                  <DropdownToggle
                            nav
                            caret
                            style={{ padding: "0.25rem 1.5rem" }}
                            onClick={this.toggleGanga} // Directly pass the method without an arrow function
                          >  Ganga
                    </DropdownToggle>
                    <DropdownItem divider />

                    {this.state.isGangaOpen &&(
                      <DropdownMenu>

                 
                    <DropdownItem>
                    <a href={urls.Kedartal}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>Kedar Tal Lake GLOF Risk Assessment</a>
                      </DropdownItem>
                   
                 

                         <DropdownItem>
                    <a href={urls.MasarTal}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>Masar Tal Lake GLOF Risk Assessment</a>
                      </DropdownItem>
                    <DropdownItem>
                    <a href={urls.Saraswati}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>Saraswati Lake GLOF Risk Assessment</a>
                      </DropdownItem>
                 
                          <DropdownItem>
                    <a href={urls.Safed}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>Safed Lake GLOF Risk Assessment</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href={urls.VasudharaTal}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>Vasudhara Tal Lake GLOF Risk Assessment</a>
                      </DropdownItem>
                  </DropdownMenu>
                    )}
              
                  </Dropdown>


                  <Dropdown isOpen={this.state.isBramhaputraOpen}  onClick={() => {
                                      this.toggleBramhaputra() }} toggle={this.toggleBramhaputra}>
                  <DropdownToggle
                    nav
                    caret
                    style={{ padding: "0.25rem 1.5rem" }}
                    onClick={this.toggleBramhaputra} // Directly pass the method without an arrow function
                  >                       Bramhaputra
                                      </DropdownToggle>

                    {this.state.isBramhaputraOpen && (
                        <DropdownMenu>
                        
                        <DropdownItem>
                    <a href={urls.SouthLhonak}  onClick={() => {
                                      this.toggleGanga() }} target="_blank" rel='noopener noreferrer'>SouthLhonak Lake GLOF Risk Assessment</a>
                      </DropdownItem>

                          <DropdownItem>
                    <a href={urls.GochungTso} target="_blank" rel='noopener noreferrer'>Gochung Tso Lake GLOF Risk Assessment</a>
                  </DropdownItem>         
                    <DropdownItem>
                    <a href={urls.Gurudongmar} target="_blank" rel='noopener noreferrer'>Gurudongmar Lake GLOF Risk Assessment</a>
                  </DropdownItem> 

                  <DropdownItem>
                    <a href={urls.KhangchungTso} target="_blank" rel='noopener noreferrer'>Khangchung Tso Lake GLOF Risk Assessment</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href={urls.Shakocho} target="_blank" rel='noopener noreferrer'>Shakocho Lake GLOF Risk Assessment</a>
                  </DropdownItem>

                  {/* <DropdownItem>
                    <a href={urls.SouthLhonak} target="_blank" rel='noopener noreferrer'>South Lhonak Lake GLOF Risk Assessment</a>
                  </DropdownItem> */}

                        {/* <DropdownItem href="#!">Indus Sub-Option 2</DropdownItem> */}
                      </DropdownMenu>

                    )}
                  
                  </Dropdown>      
                  </DropdownMenu>
                  </Dropdown>

  

          </NavItem>
        

          <NavItem  >
          <NavLink to='/nhp-data-download' >
            <Menu.Item
              name="Download Products"
              // style={this.state.active === menu.name ? activeStyle : {}}
              // onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
            </NavbarNav>

            <NavbarNav right>
              <NavItem>
                <NavLink to="/webgis-glacials/map">
                  <Menu.Item
                    name="GLOF Geoportal"
                    style={
                      this.state.active === "GLOF Geoportal" ? activeStyle : {}
                    }
                    onClick={this._handleClick.bind(this, "GLOF Geoportal")}
                  />
                </NavLink>
              </NavItem>
              {!this.state.glmodal?<NavItem className="content"><img src={info}  style={{ width: "20px", height: "20px", cursor: "pointer" }}  onClick={this.toggle} title="About"/></NavItem> :null}
            </NavbarNav>
            {/* <AuthConsumer>
                            {({ isAuth, logout }) => (
                                <NavbarNav right>
                                    {(isAuth) || (localStorage.getItem("token") !== null) ? (
                                        <NavbarNav right>
                                            <NavItem>
                                                {decode(localStorage.getItem('token')).trainee === 'trainee' ? <Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button> :
                                                    <Link to={`/profile/${decode(localStorage.getItem('token')).id}`}><Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button></Link>
                                                }         </NavItem>
                                            <NavItem><Button className="btn-sm" onClick={logout}>logout</Button></NavItem>
                                        </NavbarNav>
                                    ) : (
                                            <NavbarNav right>
                                                <NavItem>
                                                    <NavLink to="/login">Login</NavLink>

                                                </NavItem>

                                            </NavbarNav>



                                        )}

                                </NavbarNav>
                            )}
                        </AuthConsumer> */}
          </Collapse>
        </Navbar>

        <div className="main">{childrenWithExtraProp}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
